'use strict';

angular.module('systemOwnerControllers')

.controller('SelectNewBackupSystemOwnerController', ['$scope', 'searchService', function ($scope, searchService) {

    $scope.ctxSelectNewBackup = {};

    $scope.searchEmployees = function () {
        var searchTerm = $scope.ctxSelectNewBackup.searchTerm;
        if (_.isUndefined(searchTerm) || searchTerm.length < 3) {
            $scope.backupEmployees = [];
            return;
        }
        searchService.searchActiveEmployees(searchTerm)
        .then(function (foundEmployees) {
            $scope.backupEmployees = _.filter(foundEmployees, function (foundEmployee) {
                return _.findIndex($scope.actualSystemOwners, { EmployeeID: foundEmployee.EmployeeID }) === -1;
            });
        });
    }
}]);